import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const QUESTIONS = [
    { id: 'mobile', text: "Votre site est-il parfaitement lisible sur mobile ?", icon: "📱", weight: 20 },
    { id: 'ssl', text: "Avez-vous le cadenas de sécurité (HTTPS) ?", icon: "🔒", weight: 15 },
    { id: 'speed', text: "Le site charge-t-il en moins de 3 secondes ?", icon: "⚡", weight: 20 },
    { id: 'google', text: "Apparaissez-vous en 1ère page Google ?", icon: "🔎", weight: 25 },
    { id: 'reviews', text: "Avez-vous plus de 4 étoiles sur les avis ?", icon: "⭐", weight: 20 },
];

export default function CommercialDiagnosticPage() {
    const navigate = useNavigate();
    const [answers, setAnswers] = useState({}); // { mobile: true/false/null }
    const [score, setScore] = useState(null); // 0-100
    const [analyzing, setAnalyzing] = useState(false);
    const [showResult, setShowResult] = useState(false);

    const handleAnswer = (id, val) => {
        setAnswers(prev => ({ ...prev, [id]: val }));
    };

    const calculateScore = () => {
        setAnalyzing(true);
        let s = 0;
        QUESTIONS.forEach(q => {
            if (answers[q.id]) s += q.weight;
        });

        // Simuler un temps d'analyse "style scanner"
        setTimeout(() => {
            setScore(s);
            setAnalyzing(false);
            setShowResult(true);
        }, 2000);
    };

    const allAnswered = QUESTIONS.every(q => answers[q.id] !== undefined);

    const getGrade = (s) => {
        if (s >= 90) return { letter: 'A', color: '#4ade80', text: 'Excellent', sub: 'Rien à dire, continuez !' };
        if (s >= 70) return { letter: 'B', color: '#a3e635', text: 'Bon', sub: 'Quelques optimisations possibles.' };
        if (s >= 50) return { letter: 'C', color: '#facc15', text: 'Moyen', sub: 'Attention, vous perdez des clients.' };
        if (s >= 30) return { letter: 'D', color: '#f87171', text: 'Risqué', sub: 'Urgence vitale pour votre image.' };
        return { letter: 'E', color: '#ef4444', text: 'Critique', sub: 'Votre présence digitale est inexistante.' };
    };

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#0f172a', color: 'white', fontFamily: 'Inter, sans-serif', padding: 40, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

            {/* Header */}
            {!showResult && !analyzing && (
                <div style={{ textAlign: 'center', marginBottom: 50 }}>
                    <div style={{ fontSize: '3rem', marginBottom: 10 }}>🩺</div>
                    <h1 style={{ fontSize: '2.5rem', fontWeight: 800 }}>Diagnostic Flash</h1>
                    <p style={{ opacity: 0.6 }}>Répondez honnêtement pour un bilan de santé digitale.</p>
                </div>
            )}

            {/* Questions Grid */}
            {!analyzing && !showResult && (
                <div style={{ maxWidth: 800, width: '100%', display: 'flex', flexDirection: 'column', gap: 20 }}>
                    {QUESTIONS.map((q, idx) => (
                        <div key={q.id} style={{
                            background: 'rgba(255,255,255,0.05)', padding: 20, borderRadius: 16, border: '1px solid rgba(255,255,255,0.1)',
                            display: 'flex', alignItems: 'center', justifyContent: 'space-between', animation: `fadeIn 0.5s ease-out ${idx * 0.1}s forwards`, opacity: 0, transform: 'translateY(10px)'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                                <span style={{ fontSize: '1.5rem' }}>{q.icon}</span>
                                <span style={{ fontSize: '1.1rem', fontWeight: 500 }}>{q.text}</span>
                            </div>
                            <div style={{ display: 'flex', gap: 10 }}>
                                <button
                                    onClick={() => handleAnswer(q.id, false)}
                                    style={{
                                        width: 40, height: 40, borderRadius: '50%', border: 'none', cursor: 'pointer', fontSize: '1.2rem',
                                        background: answers[q.id] === false ? '#ef4444' : 'rgba(255,255,255,0.1)', color: 'white', transition: 'all 0.2s'
                                    }}
                                >
                                    ❌
                                </button>
                                <button
                                    onClick={() => handleAnswer(q.id, true)}
                                    style={{
                                        width: 40, height: 40, borderRadius: '50%', border: 'none', cursor: 'pointer', fontSize: '1.2rem',
                                        background: answers[q.id] === true ? '#22c55e' : 'rgba(255,255,255,0.1)', color: 'white', transition: 'all 0.2s'
                                    }}
                                >
                                    ✅
                                </button>
                            </div>
                        </div>
                    ))}

                    <button
                        onClick={calculateScore}
                        disabled={!allAnswered}
                        style={{
                            marginTop: 30, padding: 20, borderRadius: 50, border: 'none', fontSize: '1.2rem', fontWeight: 700, cursor: 'pointer',
                            background: allAnswered ? 'white' : 'rgba(255,255,255,0.1)', color: allAnswered ? 'black' : 'rgba(255,255,255,0.3)',
                            transform: allAnswered ? 'scale(1)' : 'scale(0.98)', transition: 'all 0.3s'
                        }}
                    >
                        {allAnswered ? "Lancer l'analyse" : "Répondez aux questions..."}
                    </button>
                    <button onClick={() => navigate('/commercial/launchpad')} style={{ background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.5)', cursor: 'pointer', marginTop: 10 }}>Annuler</button>
                </div>
            )}

            {/* Analysis Animation */}
            {analyzing && (
                <div style={{ textAlign: 'center' }}>
                    <div className="scanner" style={{ width: 100, height: 100, border: '4px solid #3b82f6', borderTopColor: 'transparent', borderRadius: '50%', margin: '0 auto 30px', animation: 'spin 1s linear infinite' }} />
                    <h2 style={{ fontSize: '2rem' }}>Analyse en cours...</h2>
                    <p style={{ opacity: 0.7 }}>Nous scannons vos opportunités de croissance.</p>
                </div>
            )}

            {/* User Result */}
            {showResult && (
                <div className="animate-pop" style={{ textAlign: 'center', maxWidth: 600 }}>
                    <div style={{
                        width: 150, height: 150, borderRadius: '50%', margin: '0 auto 30px',
                        display: 'grid', placeItems: 'center', fontSize: '4rem', fontWeight: 900,
                        border: `10px solid ${getGrade(score).color}`, color: getGrade(score).color,
                        boxShadow: `0 0 50px -10px ${getGrade(score).color}40`, background: 'rgba(255,255,255,0.05)'
                    }}>
                        {getGrade(score).letter}
                    </div>
                    <h2 style={{ fontSize: '3rem', fontWeight: 800, color: getGrade(score).color, marginBottom: 10 }}>{getGrade(score).text}</h2>
                    <p style={{ fontSize: '1.3rem', marginBottom: 40, lineHeight: 1.5 }}>
                        {getGrade(score).sub} <br />
                        <span style={{ opacity: 0.6, fontSize: '1rem' }}>Score de performance : {score}/100</span>
                    </p>

                    <div style={{ background: 'rgba(255,255,255,0.1)', padding: 20, borderRadius: 12, marginBottom: 40 }}>
                        <h3 style={{ margin: '0 0 10px 0', fontSize: '1.2rem' }}>🩹 Le remède recommandé</h3>
                        <p style={{ margin: 0, color: '#93c5fd' }}>Pack Standard - Refonte Site & SEO Local</p>
                    </div>

                    <div style={{ display: 'flex', gap: 20, justifyContent: 'center' }}>
                        <button onClick={() => { setShowResult(false); setAnswers({}); }} style={{ padding: '16px 32px', borderRadius: 50, background: 'rgba(255,255,255,0.1)', border: 'none', color: 'white', cursor: 'pointer', fontSize: '1rem', fontWeight: 600 }}>Recommencer</button>
                        <button onClick={() => navigate('/commercial/configurator')} style={{ padding: '16px 32px', borderRadius: 50, background: 'white', border: 'none', color: 'black', cursor: 'pointer', fontSize: '1rem', fontWeight: 600 }}>Voir la solution →</button>
                    </div>
                </div>
            )}

            <style>{`
                @keyframes spin { to { transform: rotate(360deg); } }
                @keyframes fadeIn { to { opacity: 1; transform: translateY(0); } }
                .animate-pop { animation: popIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275); }
                @keyframes popIn { from { opacity: 0; transform: scale(0.8); } to { opacity: 1; transform: scale(1); } }
            `}</style>
        </div>
    );
}
